import {MeasurementType} from "../measurement-models";
import {LocalizationStrings} from "../../i18n/i18n-model";

const homeMeasurementInstructionsWithLinkByType: Map<MeasurementType, keyof LocalizationStrings> = new Map([
  ["SLEEP", "sleepHomeMeasurementInstructionsWithLink"],
  ["HOLTER_ECG", "holterHomeMeasurementInstructionsWithLink"],
  ["SYMPTOM_HOLTER", "symptomHolterHomeMeasurementInstructionsWithLink"],
  ["BLOOD_PRESSURE", "bloodPressureHomeMeasurementInstructionsWithLink"],
  ["ECG_ATRIAL_FIBRILLATION", "atrialFibrillationHomeMeasurementInstructionsWithLink"],
]);

export function selectHomeMeasurementInstructionsLocalizationKey(type: MeasurementType): keyof LocalizationStrings {
  return homeMeasurementInstructionsWithLinkByType.get(type)!;
}
